import React from "react";
import { createBrowserHistory } from "history";
import { SnackbarProvider } from "notistack";
import { Router, BrowserRouter } from "react-router-dom";
import routes, { renderRoutes } from "./routes";
import { AuthProvider } from "./contextapi/contexts/AuthContextProd";
import ThemeProvider from "./theme";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/scroll-to-top";
import { ConfirmDialog } from "./components";
import { AuditoriaDialog } from "./components";

const App = () => {
  const history = createBrowserHistory();

  return (
    <ThemeProvider>
      <HelmetProvider>
        <BrowserRouter>
          <SnackbarProvider dense maxSnack={3}>
            <Router history={history} basename={process.env.REACT_APP_URL_API}>
              <AuthProvider>
                <ConfirmDialog />
                <AuditoriaDialog />

                <ScrollToTop />
                {renderRoutes(routes)}
              </AuthProvider>
            </Router>
          </SnackbarProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ThemeProvider>
  );
};

export default App;
